import React from 'react'
import {
  SubscriptionContainer,
  Container,
  MoveLicenseContainer,
  ContainerHeader,
} from './EditLicensePrevSub.styles'
import { MOVE_LICENSE_DESCRIPTION, NO_RESULTS_MESSAGE } from './constants'

const EditLicensePrevSub = props => {
  const { previousSubscription, name, values, setFieldValue } = props
  let previousSub = previousSubscription && previousSubscription[0]
  const customerName =
    previousSub &&
    previousSub.payerNetsuiteCustomer &&
    previousSub.payerNetsuiteCustomer.companyName
      ? previousSub.payerNetsuiteCustomer.companyName
      : ''
  const prevSubExists = !!previousSubscription
  return (
    <Container>
      <ContainerHeader>Previous Subscription ID:</ContainerHeader>
      <SubscriptionContainer>
        {prevSubExists ? (
          <React.Fragment>
            <p>NS: {previousSub.nsSubscriptionId}</p>
            <p>Customer Name: {customerName}</p>
            <p>
              {`Expiration Date: ${previousSub.expirationDate.split('T')[0]}`}
            </p>
          </React.Fragment>
        ) : (
          <p> {NO_RESULTS_MESSAGE} </p>
        )}
      </SubscriptionContainer>
      {prevSubExists && (
        <MoveLicenseContainer>
          <input
            checked={values}
            name={name}
            onChange={() => {
              setFieldValue('moveSubscription', !values)
            }}
            type="checkbox"
          />
          <span>{MOVE_LICENSE_DESCRIPTION}</span>
        </MoveLicenseContainer>
      )}
    </Container>
  )
}

export default EditLicensePrevSub



// WEBPACK FOOTER //
// ./src/components/EditLicensePrevSub/EditLicensePrevSub.js